var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-subscription-category-table',{attrs:{"title":_vm.$t('global.models.subscription-category.heading'),"subtitle":_vm.$t('global.models.subscription-category.subheading'),"selectConfigName":['part1', 'part2']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }